import React from 'react';
import { Heading, P, NavButtons } from './Shell';
import { Field, TextInput, TermsBlock, CaptchaBox, inputCls } from './Fields';
import RecaptchaBox from './RecaptchaBox';
import SignaturePad from '../SignaturePad';

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Step2 = ({ data, setField, errors, onNext, onBack, challenge, captcha, setCaptcha, refreshChallenge }) => {
  const date = data.date || {};
  const signedOn = date.year ? `${MONTH_NAMES[Number(date.month) - 1]} ${Number(date.day)}, ${date.year}` : '';
  return (
    <div data-testid="onboarding-step-2">
      <div className="border-t border-white/70 pt-2 space-y-1">
        <Field id="name" label="Name" required error={errors.name}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div><TextInput value={data.first_name || ''} onChange={(e) => setField('first_name', e.target.value)} data-testid="ob-first-name" autoComplete="given-name" /><div className="text-[12px] text-white/80 mt-1">First Name</div></div>
            <div><TextInput value={data.last_name || ''} onChange={(e) => setField('last_name', e.target.value)} data-testid="ob-last-name" autoComplete="family-name" /><div className="text-[12px] text-white/80 mt-1">Last Name</div></div>
          </div>
        </Field>
        <Field id="phone" label="Phone Number" required error={errors.phone} hint="Please enter a valid phone number. Format: (000) 000-0000.">
          <TextInput value={data.phone || ''} onChange={(e) => setField('phone', e.target.value)} data-testid="ob-phone" type="tel" placeholder="(000) 000-0000" className={`${inputCls} max-w-[420px]`} />
        </Field>
        <Field id="email" label="Email" required error={errors.email}>
          <TextInput value={data.email || ''} onChange={(e) => setField('email', e.target.value)} data-testid="ob-email" type="email" placeholder="example@example.com" className={`${inputCls} max-w-[420px]`} />
        </Field>

        <div className="px-3 pt-4">
          <Heading>Purpose of Data Processing</Heading>
          <P>Your personal data will be collected and used for the following purposes:</P>
          <P>To provide the services or products requested.<br />To communicate with you about updates, offers, and related services.<br />To comply with legal or regulatory requirements.<br />For internal record-keeping and improving our products or services.</P>
          <Heading>Your Rights</Heading>
          <P>Access the personal data we hold about you.<br />Request correction of inaccurate or incomplete data.<br />Request deletion of your personal data (subject to legal obligations).<br />Withdraw your consent at any time.</P>
        </div>

        <TermsBlock id="terms_data" checked={data.terms_data} onChange={(v) => setField('terms_data', v)} error={errors.terms_data} />

        <Field id="signature" label="Signature" required error={errors.signature}>
          <div className="bg-white rounded-sm p-2 max-w-[560px]">
            <SignaturePad id="ob-signature" value={data.signature} onChange={(v) => setField('signature', v)} invalid={!!errors.signature} />
          </div>
        </Field>

        <Field id="date" label="Date" required error={errors.date} hint="Set automatically to the day you sign — no need to fill this in.">
          <div className="flex flex-wrap items-center gap-3">
            <div data-testid="ob-date-auto" aria-readonly="true"
              className="px-3 py-2 rounded-sm bg-white/95 text-[#2C3345] text-[15px] font-semibold min-w-[200px]">
              {signedOn || '—'}
            </div>
            <span className="text-[13px] text-white/80">Today&apos;s date</span>
          </div>
        </Field>

        {challenge?.mode === 'recaptcha'
          ? <RecaptchaBox siteKey={challenge.site_key} onToken={setCaptcha} error={errors.captcha} resetKey={challenge.reset || 0} />
          : <CaptchaBox challenge={challenge} value={captcha} onChange={setCaptcha} error={errors.captcha} onRefresh={refreshChallenge} />}
      </div>
      <NavButtons onBack={onBack} onNext={onNext} hasErrors={Object.keys(errors).length > 0} />
    </div>
  );
};

export default Step2;
